<template>
  <div class="form-container">
    <h1 class="mb-4">顧客情報編集</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>

      <div class="mb-3">
        <label for="customerName" class="form-label">顧客名 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="customer.customer_nm" type="text" placeholder="顧客名" class="form-control" id="customerName" required>
        <div v-if="errorMessages.customer_nm" class="alert alert-danger mt-2">{{ errorMessages.customer_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="customerNo" class="form-label">顧客番号</label>
        <input v-model="customer.customer_no" type="text" placeholder="顧客番号" class="form-control" id="customerNo">
        <div v-if="errorMessages.customer_no" class="alert alert-danger mt-2">{{ errorMessages.customer_no[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="postalCode" class="form-label">郵便番号</label>
        <input v-model="customer.postal_code" type="text" placeholder="郵便番号" class="form-control" id="postalCode">
        <div v-if="errorMessages.postal_code" class="alert alert-danger mt-2">{{ errorMessages.postal_code[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="prefecture" class="form-label">都道府県</label>
        <input v-model="customer.prefecture" type="text" placeholder="都道府県" class="form-control" id="prefecture">
        <div v-if="errorMessages.prefecture" class="alert alert-danger mt-2">{{ errorMessages.prefecture[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="city" class="form-label">市区町村</label>
        <input v-model="customer.city" type="text" placeholder="市区町村" class="form-control" id="city">
        <div v-if="errorMessages.city" class="alert alert-danger mt-2">{{ errorMessages.city[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="otherAddress" class="form-label">その他の住所</label>
        <input v-model="customer.other_address" type="text" placeholder="その他の住所" class="form-control" id="otherAddress">
        <div v-if="errorMessages.other_address" class="alert alert-danger mt-2">{{ errorMessages.other_address[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="telNum" class="form-label">電話番号</label>
        <input v-model="customer.tel_num" type="text" placeholder="電話番号" class="form-control" id="telNum">
        <div v-if="errorMessages.tel_num" class="alert alert-danger mt-2">{{ errorMessages.tel_num[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="fax" class="form-label">FAX</label>
        <input v-model="customer.fax" type="text" placeholder="FAX" class="form-control" id="fax">
        <div v-if="errorMessages.fax" class="alert alert-danger mt-2">{{ errorMessages.fax[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="presidentNm" class="form-label">代表者名</label>
        <input v-model="customer.president_nm" type="text" placeholder="代表者名" class="form-control" id="presidentNm">
        <div v-if="errorMessages.president_nm" class="alert alert-danger mt-2">{{ errorMessages.president_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="billingNm" class="form-label">請求先名</label>
        <input v-model="customer.billing_nm" type="text" placeholder="請求先名" class="form-control" id="billingNm">
        <div v-if="errorMessages.billing_nm" class="alert alert-danger mt-2">{{ errorMessages.billing_nm[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getCustomer, updateCustomer } from '@/api/axios';

export default {
  setup() {
    const title = ref('顧客情報編集');

    watchEffect(() => {
      document.title = title.value;
    });

    const customer = ref({
      customer_nm: '',
      customer_no: '',
      postal_code: '',
      prefecture: '',
      city: '',
      other_address: '',
      tel_num: '',
      fax: '',
      president_nm: '',
      billing_nm: ''
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const customerId = route.params.id; // URLから顧客情報IDを取得

    const loadCustomerData = async () => {
      try {
        const response = await getCustomer(customerId, { include_visibility_hidden: true });
        customer.value = response.data;
      } catch (error) {
        console.error('顧客情報データの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      try {
        await updateCustomer(customerId, customer.value, { include_visibility_hidden: true });
        store.commit('setFlashMessage', {message: '顧客情報更新完了！', type: 'success'});
        router.push(`/customers/${customerId}`);
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.commit('setFlashMessage', {message: '顧客情報更新失敗！', type: 'danger'});
        console.error('更新エラー:', error);
      }
    };

    onMounted(loadCustomerData);

    return {
      title,
      customer,
      handleSubmit,
      errorMessages
    };
  }
};
</script>

<style scoped>
.form-container {
  padding: 20px 20px 80px 20px;
  width: 70%;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

input[type="text"],
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 4px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.btn-area{
  text-align: center;
}
</style>
